import { c as _c } from "react/compiler-runtime";
import { useActiveAdministrative } from './useAdministrativeLevels';
export const useActiveVillage = () => {
  const $ = _c(8);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      level: "village",
      paramKey: "filter[village]",
      parents: [{
        paramKey: "filter[subdistrict]",
        argName: "subdistrict"
      }, {
        paramKey: "filter[district]",
        argName: "district"
      }]
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const r = useActiveAdministrative(t0);
  let t1;
  if ($[1] !== r.active || $[2] !== r.activeLabel || $[3] !== r.isLoading || $[4] !== r.items || $[5] !== r.selectedParam || $[6] !== r.setActive) {
    t1 = {
      villageParam: r.selectedParam,
      villages: r.items,
      activeVillage: r.active,
      activeVillageLabel: r.activeLabel,
      isLoading: r.isLoading,
      setActiveVillage: r.setActive
    };
    $[1] = r.active;
    $[2] = r.activeLabel;
    $[3] = r.isLoading;
    $[4] = r.items;
    $[5] = r.selectedParam;
    $[6] = r.setActive;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1 as const;
};